import { Component, OnInit } from '@angular/core';
import { MainNavigationItem, patientsNavItems, healthWorkersNavItems } from './main-navigation-item.constants';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'main-navigation',
  templateUrl: './main-navigation.component.html',
  styleUrls: ['./main-navigation.component.scss']
})
export class MainNavigationComponent implements OnInit {

  navigationItems: MainNavigationItem[];
  subscription$ = new Subject();
  navigationType: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.navigationItems = patientsNavItems;
    this.route.params
      .pipe(takeUntil(this.subscription$))
      .subscribe(({type}) => {
        this.navigationType = type;
        if(type === 'patients')
          this.navigationItems = patientsNavItems;
        else this.navigationItems = healthWorkersNavItems;
      })
  }

  showLoginItem(): boolean {
    return this.navigationType === 'health_workers';
  }

}
